export enum TutorType {
    F = 'Finale',
    K = 'Ok',
    P = 'Pochi',
    T = 'Tanti',
    R = 'Risultato',
    D = 'Dettaglio'
}